import React from 'react';
import Content from './Content';
import MediaCenterContent from '../../MediaCenterContent';
import { useBagContext } from '../../../../../../../services/bag';
import { MediaCenterController } from '../../../../../../../hooks/useMediaCenterController';
import {
  LIST_FILES,
  DELETE_FILE,
  UPDATE_FILE,
  CREATE_FILE,
} from '../../graphql';
import { useTranslation } from 'react-i18next';

export default function MediaCenterSlider(): JSX.Element {
  const { media } = useBagContext<MediaCenterController>();
  const { t } = useTranslation('mediaCenter');
  const type = 'inclusion';

  return (
    <MediaCenterContent
      content={() =>
        Content({
          type,
        })
      }
      deleteGql={DELETE_FILE}
      refetchQuery={LIST_FILES}
      updateGql={UPDATE_FILE}
      createGql={CREATE_FILE}
      acceptFiles="image/*"
      filesDescription={t('Image Files')}
      type={type}
      {...media}
    />
  );
}
